import { Box } from '@mui/material';
import { ContainedButton } from 'components/ContainedButton';
import { DeleteConfirmationModal } from 'components/delete-confirmation';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import LineItems from '../line-items/Line-Items';
import PartiesMortgage from './components/parties-mortgage';
import PayOffInfo from './components/payoff-info-form';
import TitleSection from './components/title-section';
import useMortgageDetails from './mortgage-details-hooks';
import { useStyles } from './styles';

const MortgageDetail = () => {
  const { currentMortgage, deleteMortgageMutation, deleteMortgageResponse, id } = useMortgageDetails();
  const classes = useStyles();
  const { t } = useTranslation();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  return (
    <Box className={classes.container}>
      <Box className={classes.actions}>
        <ContainedButton
          text={t('common:delete')}
          icon="trash"
          disabled={deleteMortgageResponse.isLoading}
          onClick={() => setIsDeleteModalOpen(true)}
        />
      </Box>
      <Box className={classes.sections}>
        <Box className={classes.infoArea}>
          <TitleSection title={t('payoffs:recording_information')}>
            <PayOffInfo currentMortgage={currentMortgage} />
          </TitleSection>
        </Box>
        <Box className={classes.linesArea}>
          <LineItems
            accounting={currentMortgage?.accounting || []}
            mortgateId={currentMortgage?._id!}
          />
        </Box>
        <Box className={classes.partiesArea}>
          <PartiesMortgage currentMortgage={currentMortgage} t={t} />
        </Box>
      </Box>
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        title={t('payoffs:delete-payoff')}
        confirmationMessage={t('payoffs:delete-payoff-confirmation')}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={() => {
          if (currentMortgage?._id) {
            deleteMortgageMutation({ id, mortgageId: currentMortgage._id });
            setIsDeleteModalOpen(false);
          }
        }}
        isRemoveLoading={deleteMortgageResponse.isLoading}
        buttonConfirmText={t('common:delete')}
      />
    </Box>
  );
};

export default MortgageDetail;
